import type { Icon } from '@phosphor-icons/react';
import {
  ArrowsClockwiseIcon,
  CalendarIcon,
  ChatCenteredTextIcon,
  FilesIcon,
  FlowArrowIcon,
  GlobeIcon,
  ImagesIcon,
  NewspaperIcon,
  PaletteIcon,
  QuotesIcon,
  RocketLaunchIcon,
  UserCircleIcon,
  VideoCameraIcon,
} from '@phosphor-icons/react';
import type { SVGProps } from 'react';

import { CampaignLineIcon } from '@/components/ui/illustrations';
import { createLogger } from '@/utils/logger';

const log = createLogger('resolveWorkflowIcon');

export type WorkflowIconComponent = Icon | React.ComponentType<SVGProps<SVGSVGElement>>;

export function resolveWorkflowIcon(iconId?: string): WorkflowIconComponent {
  switch (iconId) {
    case 'chat-bubble':
      return ChatCenteredTextIcon;
    case 'quotes':
      return QuotesIcon;
    case 'globe':
      return GlobeIcon;
    case 'newspaper':
      return NewspaperIcon;
    case 'article-multi':
      return FilesIcon;
    case 'founder':
      return UserCircleIcon;
    case 'photos':
      return ImagesIcon;
    case 'rocket':
      return RocketLaunchIcon;
    case 'brand':
      return PaletteIcon;
    case 'repurpose':
      return ArrowsClockwiseIcon;
    case 'ugc':
      return VideoCameraIcon;
    case 'calendar':
      return CalendarIcon;
    case 'flow':
    case undefined:
      return FlowArrowIcon;
    default:
      if (iconId && import.meta.env.DEV) {
        log.warn(
          `Unknown icon_id: '${iconId}'. Falling back to CampaignLineIcon. Add a mapping in resolveWorkflowIcon.ts.`,
        );
      }
      return CampaignLineIcon;
  }
}
